<template>
  <div>
    <LogoHome />
    <v-container fluid grid-list-md text-center>
      <v-layout row wrap>
        <v-flex xs12 md4 offset-md4>
          <v-card
            class="elevation-15 clickable transparente pa-1"
            v-ripple="{ center: true }"
            @click="abrirOpcion('Venta')"
            dark
          >
            <v-card-text>
              <span class="overline">Facturador</span>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 md4 offset-md4>
          <v-card
            class="elevation-15 clickable transparente pa-1"
            v-ripple="{ center: true }"
            @click="abrirOpcion('ArticuloConsultaPrecio')"
            dark
          >
            <v-card-text>
              <span class="overline">Consulta de Precios</span>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import LogoHome from "@/components/LogoHome";
export default {
  name: "HomePos1",
  components: {
    LogoHome
  },
  methods: {
    abrirOpcion(ruta) {
      if (ruta != this.$route.name)
        this.$router.push({ name: ruta, params: {} });
    }
  }
};
</script>
